import { Suspense, type ComponentType, type LazyExoticComponent } from 'react';
import { ProtectedRoute } from './ProtectedRoute';
import { ErrorBoundary } from './ErrorBoundary';
import { PageLoading } from './PageLoading';
import type { UserRole } from '../context/AuthContext';

interface LazyRouteProps {
  component: LazyExoticComponent<ComponentType<any>>;
  allowedRoles?: UserRole[];
}

/**
 * LazyRoute - Combina React.lazy() com Suspense, ErrorBoundary e ProtectedRoute.
 * Garante fallback de loading enquanto o chunk carrega, captura de erros e proteção por role.
 */
export function LazyRoute({ component: Component, allowedRoles }: LazyRouteProps) {
  const content = (
    <ErrorBoundary>
      <Suspense fallback={<PageLoading />}>
        <Component />
      </Suspense>
    </ErrorBoundary>
  );

  if (allowedRoles) {
    return <ProtectedRoute allowedRoles={allowedRoles}>{content}</ProtectedRoute>;
  }

  return content;
}